import LazyLoadImages from "./events/ImageLoaded";

import StarterKit from "./StarterKit";

import BlockBanner from "./blocks/BlockBanner";
import BlockBannerHome3D from "./blocks/BlockBannerHome3D";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockSliderSimple from "./blocks/BlockSliderSimple";
import BlockSolutions from "./blocks/BlockSolutions";
import BlockSolutionsCarousel from "./blocks/BlockSolutionsCarousel";
import BlockTextPinCover from "./blocks/BlockTextPinCover";
import BlockTimeline from "./blocks/BlockTimeline";

// First of the first
new LazyLoadImages();

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	new StarterKit();

	// Blocks
	new BlockBanner();
	new BlockBannerHome3D();
	new BlockCollapse();
	new BlockSliderSimple();
	new BlockSolutions();
	new BlockSolutionsCarousel();
	new BlockTextPinCover();
	new BlockTimeline();
});
